import CreditCards from 'components/RichProfile/CreditCards/CreditCards';
import withGlobalModals from 'hocs/withGlobalModals';

const ConnectedCreditCards = withGlobalModals(CreditCards);

export default ConnectedCreditCards;
